export enum NotificationJobStatus {
Pending,
Completed,
Canceled,
}
